module.exports = "<div gw-loader=\"getNotesPromise\">\r\n    <div gw-notes-list notes=\"notes\"\r\n         job-number=\"{{cancellationNumber}}\"\r\n         create-label=\"{{'gateway.views.cancellation-detail.Note'|translate}}\"\r\n         empty-message=\"{{'gateway.views.cancellation-detail.No notes associated with this cancellation'|translate}}\">\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/views/cancellation/cancellation-notes.html
// module id = 790
// module chunks = 0